import { AlertLicense } from 'o2o_layout';
import React, { CSSProperties } from 'react';

import { useLicense } from '../contexts/license.context';
import { useSelector } from '@redux/store';
import { IState } from '@redux/reducer';
import { BIGDATA_CONSTANT } from '../../../common/constant';

type TProps = {
  className?: string;
  style?: CSSProperties;
  user?: any;
  orgIds?: string[];
  domainAccountUrl?: string;
  currentAppUrl?: string;
};

const AlertLicenseComponent = (props: TProps) => {
  const { response } = useLicense();
  const user = useSelector((state: IState) => state.user);

  return (
    <AlertLicense
      {...props}
      user={user}
      response={response}
      domainAccountUrl={BIGDATA_CONSTANT.url.apps.REACT_APP_ACCOUNT_APP}
      currentAppUrl={BIGDATA_CONSTANT.url.apps.REACT_APP_ACCOUNT_APP}
    />
  );
};

export default AlertLicenseComponent;
